export const BOARD_NUM_ROWS = 6;
export const BOARD_NUM_COLS = 7;

export const turnTransitionTime = 700; // ms